import { sendErrorToServices } from 'lib/logging';
import { useEffect } from 'react';

interface ErrorHandlingProps {
  player: HTMLVideoElement | null;
  onError: (error: Error) => void;
}

export function useErrorHandling({ player, onError }: ErrorHandlingProps) {
  useEffect(() => {
    if (!player) return;

    const hls = (player as any).hlsPlayer;
    if (!hls) return;

    const handleHLSError = data => {
      const { type, details, fatal } = data;

      if (fatal) {
        sendErrorToServices('HLS Fatal Error', {
          type,
          details,
          url: data.url,
          response: data.response
        });

        // Try to recover by switching to a lower quality
        if (hls.currentLevel > 0) {
          hls.currentLevel = hls.currentLevel - 1;
        }
      }

      onError(new Error(`HLS Error: ${type} - ${details}`));
    };

    const handleVideoError = () => {
      sendErrorToServices('Video Error', {
        code: player.error?.code,
        message: player.error?.message,
        currentTime: player.currentTime,
        readyState: player.readyState
      });

      onError(new Error(`Video Error: ${player.error?.message}`));
    };

    hls.on('hlsError', handleHLSError);
    player.addEventListener('error', handleVideoError);

    return () => {
      hls.off('hlsError', handleHLSError);
      player.removeEventListener('error', handleVideoError);
    };
  }, [player, onError]);
}
